import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Page from 'Common/Layout/Page';
import CloseButton from '../../../../../Common/CloseButton/CloseButton';
import AppointeeDatatable from '../../Datatable/AppointeeDatatable';
import AppointeeColumns from '../../Columns/AppointeeColumns';
import AppointeeExceptionReasonsColumns from '../../Columns/AppointeeExceptionReasonsColumns';

import {
	getAppointeeExceptionReason,
	getAppointeeExceptionReasonExport,
	getAppointeeExceptionReasonDetails
} from '../../../../../Redux/Actions/Appointee.Contract.Actions';
import classes from '../appointee-management.module.css';

import { withClsCompTracking } from '../../../../../Telemetry/telemetry.service';

const AppointeeExceptionReasonsDataTable = withClsCompTracking('Appointee Exception Reasons Table')(AppointeeDatatable);

const AppointeeExceptionReasons = ({ handleActiveModal }) => {
	const dispatch = useDispatch();
	const qualification_year = useSelector(state => state.contract_globals.qualification_year.selected);
	const types = useSelector(state => state.contract_globals.appointment_types.selected);
	const { apiCallCompleted, appointeeData, appointeeDataDetails, appointeeDataExport } = useSelector(state => state.appointeeReducer);
	const handleGetAppointeeExceptionReason = (year, contractTypes, query) => dispatch(getAppointeeExceptionReason(year, contractTypes, query));
	const handleGetAppointeeExceptionReasonExport = (year, contractTypes, query) =>
		dispatch(getAppointeeExceptionReasonExport(year, contractTypes, query));
	const handleGetAppointeeExceptionReasonDetails = (markingTeamId, year, markingTeamCode, contractTypes, query) =>
		dispatch(getAppointeeExceptionReasonDetails(markingTeamId, year, markingTeamCode, contractTypes, query));

	return (
		<>
			<Page title="Appointee Exception Reasons">
			</Page>
			<AppointeeExceptionReasonsDataTable
				mainKeyField={'markingTeamId'}
				detailsKeyField={'appointeeId'}
				mainColumns={AppointeeColumns()}
				detailsColumns={AppointeeExceptionReasonsColumns()}
				contractTypes={types}
				selectedYear={qualification_year}
				handleGetData={handleGetAppointeeExceptionReason}
				handleGetDataExport={handleGetAppointeeExceptionReasonExport}
				handleGetDataDetails={handleGetAppointeeExceptionReasonDetails}
				apiCallCompleted={apiCallCompleted}
				mainTableData={appointeeData}
				detailsTableData={appointeeDataDetails}
				mainExportData={appointeeDataExport}
				detailsExportData={appointeeDataDetails}
			/>
			<span className={classes['action-buttons']}>
				<CloseButton closeOnClick={() => handleActiveModal('')} />
			</span>
		</>
	);
};

export default AppointeeExceptionReasons;
